

import React, { Component, useEffect, useState } from "react";
import joi from "joi";
import { Modal, Container, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
// import EquipmentType from './../EquipmentType/EquipmentType';
import swal from "sweetalert";
import validation from "../../../src/utill/validation";
import { Row, Space } from "antd";
import axios from "axios";
import api from "../../../src/config.json";
import Table from "../../../src/Common/table";
import dateTime from "../../../src/utill/dateTime";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Excelimport from "../../../src/utill/Excelimport";
import Loading from "../../../src/utill/LoadingComponent";
import { Select as AntdSelect } from "antd";
import { QRCodeSVG } from "qrcode.react";
import XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import _ from "lodash";
import { generateExcelFile } from "../../utill/download";
import moment from "moment";

const BatchCodeReport = ({ RightName, getRightsForAccess, Heading }) => {
  const [sortColumn, setSortColumn] = useState({ path: 'PartID', order: 'asc' });
  const [Inputdata, setInputData] = useState({});
  const [Inputdata1, setInputData1] = useState({});

  const [FIELDName, setFIELDName] = useState('');
  const [tabledata, settabledata] = useState({});
  const [loader, setLoader] = useState(false);
  const [templateList, setTemplateList] = useState([{Name:'Traceability Number',value:'Traceability Number'},{Name:'Batch Number',value:'Batch Number'}]);
  const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] });
  const [errors, seterrors] = useState({});
  const [DataList, setDataList] = useState([]);

  console.log(Inputdata,"vsfdhbsd")
const [columns, setColumns] = useState([
    { path: "Reservoir_ID", label: "Reservoir ID" },
    { path: "RawMaterialID", label: "Raw Material Id" },
    { path: "Vendor", label: "Vendor" },
    { path: "InvoiceDate", label: "Invoice Date" ,content: obj => <React.Fragment>
            <label>
             {moment(obj.InvoiceDate).format('DD-MM-YYYY')}
            </label>
          </React.Fragment>
      },
    { path: "InvoiceNo", label: "Invoice No" },

 
   
]);
const [columns2, setColumns2] = useState([
  { path: "RawMaterialID", label: "Raw Material Id" },
  { path: "Vendor", label: "Vendor" },
  { path: "InvoiceDate", label: "Invoice Date" ,content: obj => <React.Fragment>
          <label>
           {moment(obj.InvoiceDate).format('DD-MM-YYYY')}
          </label>
        </React.Fragment>
    },
  { path: "InvoiceNo", label: "Invoice No" },


 
]);
const [columns1, setColumns1] = useState([
  { path: "Date", label: "Date" },
  { path: "Time", label: "Time" },
  { path: "Tool_ID", label: "Tool ID" },
  { path: "TracibilityNumber", label: "Traceability Number" },
  { path: "Qty", label: "Qty" },
  { path: "Result", label: "Result" },



]);

  useEffect(() => {

    Heading("Batch Report");
    getBatchList();
  }, []);


  const getBatchList = () => {
    axios
      .get(api.api + "FetchBatchCodes")
      .then((result) => {
       

        const list = result.data.map(one=>({Name: one,value: one}))
        setDataList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleSort = sortColumn => {
    if (tabledata.length > 0) {
      const sorted = _.orderBy(tabledata, [sortColumn.path], [sortColumn.order]);
      setSortColumn(sortColumn)
      settabledata(sorted)
    }
  }

  const schema = {
    BatchCode: joi.string().required(),
  };
  const handleDownloadExcel = (e) => {
    generateExcelFile(e);
  };
  

  const handleOnChange = (e) => {
    const { name, value } = e.currentTarget;



setInputData({[name]:value})
  };

  const handelGetData = (data) => {
    // Create a copy of the input data
    const checksheet = { ...data };
  
    // Validate the checksheet data using the schema
    const errors = validation.validate(checksheet, schema);
    if (errors) {
      seterrors(errors);
      return; // Stop execution if there are validation errors
    }
  
    // Set loader to true before making the API call
    setLoader(true);
  
    axios
      .put(`${api.api}Count`, checksheet)
      .then((result) => {
        console.log(result.data, "API data received");
  
        // Update the table data with the response
        settabledata(result.data);
      })
      .catch((err) => {
        // Handle API errors and display appropriate messages
        if (err.response && err.response.data) {
          swal(err.response.data.message, { dangerMode: true });
        } else {
          console.error("An unexpected error occurred:", err);
        }
      })
      .finally(() => {
        // Ensure the loader is turned off after the API call
        setLoader(false);
      });
  };
  
  return (
    <>
     
      {loader ? <Loading /> : <></>}
      <div className="">
  <Row className="">

    { <Col sm={3}>
      <div className="form-group mt-2">
        <label htmlFor="operationRejectionCost" className="fw-bold">{'BatchCode'}</label>
        <AntdSelect
          placeholder={'BatchCode'}
          onChange={(value) => {
            // const template = templateList.find((x) => x.Name == value);
            // setSelectedTemplate(template || {});
            handleOnChange({
              currentTarget: { name: 'BatchCode', value: value },
            });
          }}
          value={Inputdata['BatchCode']|| []}
          style={{ width: "100%" }}
        >
          {DataList.map((one) => {
            return (
              <AntdSelect.Option key={one.Name} value={one.Name}>
                {one.Name}
              </AntdSelect.Option>
            );
          })}
        </AntdSelect>
        {errors.TraceBy && (
          <div className="alert small alert-danger">
            {errors["TraceBy"]}
          </div>
        )}
      </div>
    </Col>}
    <Col sm={2} className="d-flex align-items-center">
      <button
        // disabled={!getRightsForAccess("StaticDataRights", RightName, "write")}
        className="btn-sm btn-primary mt-3"
        onClick={() => {
          handelGetData(Inputdata)
        }}
      >
    
        Apply
      </button>
    </Col>
  </Row>
</div>

<div className="">

{tabledata && tabledata.GreenSheetAvailable && tabledata.TotalGreenSheetsQtyProduced && <div className="">

<h4 className="">Total Green Sheet Produced : {tabledata.TotalGreenSheetsQtyProduced} </h4>
<h4 className="">Green Sheet Available : {tabledata.GreenSheetAvailable} </h4>

</div>
}
    </div>
    </>
  );
};

export default BatchCodeReport;



